// Re-export the apiService from services/api.js for compatibility
import apiService from '../services/api';

export default apiService;